import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ColorService {
    private readonly DEFAULT_HUE = 145;

    constructor() {
        this.setPrimaryHue(this.DEFAULT_HUE);
    }

    setPrimaryHue(hue: number): void {
        const validHue = Math.max(0, Math.min(360, hue));
        document.documentElement.style.setProperty('--primary-hue', validHue.toString());
    }

    getPrimaryHue(): number {
        const hue = getComputedStyle(document.documentElement)
            .getPropertyValue('--primary-hue')
            .trim();
        return parseInt(hue, 10) || this.DEFAULT_HUE;
    }
}